/**
* DevExpress Analytics (core\internal\fetchSetup.js)
* Version:  23.1.7
* Build date: Dec 11, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export var fetchSetup = {
    fetchSettings: {}
};
